module.exports = __webpack_public_path__ + "static/media/minusIcon.bcc5b319.svg";